import { AnyRoute, createRoute, lazyRouteComponent, notFound } from '@tanstack/react-router'
import { NotFoundError } from 'commons/errors'
import * as z from 'zod'
import { getPeriodDetails } from '~bank-documents/service/periodDetails'

const sch = z.object({
  historyPage: z.number().int().positive().optional(),
  historySize: z.number().int().positive().optional()
})

export const periodDetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '$documentId/periods/$periodId',
    // for future versions on tanstack-router
    // params: {
    //   parse: (params) => ({
    //     documentId: z.number().int().parse(Number(params?.documentId)),
    //     periodId: z.number().int().parse(Number(params?.periodId))
    //   }),
    //   stringify: ({ documentId, periodId }) => ({ documentId: `${documentId}`, periodId: `${periodId}` })
    // },
    validateSearch: (search: Record<string, unknown>) => sch.parse(search),
    loaderDeps: ({ search: { historyPage, historySize } }) => ({ historyPage, historySize }),
    beforeLoad: ({ params }) => {
      if ('periodId' in params) return { id: Number(params.periodId) }
      else throw new NotFoundError()
    },
    loader: ({ context: { id }, deps }) =>
      getPeriodDetails({
        id: id,
        historyPage: deps.historyPage,
        historySize: deps.historySize
      }),
    shouldReload: (p) => p.location.href !== p.route.path,
    component: lazyRouteComponent(() => import('./PeriodDetails')),
    onError: async () => {
      throw notFound()
    }
  })
